import { useInfiniteQuery } from '@tanstack/react-query';

import PromptsService, {
  FilterPromptVariablesDto,
} from '@/services/PromptsService';

export const GET_PROMPT_VARIABLES_QUERY_KEY = (
  filters: FilterPromptVariablesDto,
) => ['prompt-variables', filters];

export function useGetPromptVariables(
  filters: Omit<FilterPromptVariablesDto, 'currentPage'>,
) {
  const { data, isFetching, isFetchingNextPage, hasNextPage, fetchNextPage } =
    useInfiniteQuery({
      queryKey: GET_PROMPT_VARIABLES_QUERY_KEY(filters),
      initialPageParam: 1,
      queryFn: ({ pageParam }) =>
        PromptsService.getPromptVariables({
          ...filters,
          page: pageParam,
          limit: filters.limit ?? 10,
        }),
      getNextPageParam: (lastPage, _allPages, lastPageParam) => {
        const { currentPage, totalPages } = lastPage;

        if (currentPage === totalPages || totalPages === 0) {
          return null;
        }

        return lastPageParam + 1;
      },
    });

  const promptVariables = data?.pages.flatMap((page) => page?.items);

  return {
    promptVariables: promptVariables ?? [],
    isFetching,
    isFetchingNextPage,
    hasNextPage,
    fetchNextPage,
  };
}
